import { render } from "./offerPage.vue?vue&type=template&id=84b48366&scoped=true"
import script from "./offerPage.vue?vue&type=script&lang=js"
export * from "./offerPage.vue?vue&type=script&lang=js"

import "./offerPage.vue?vue&type=style&index=0&id=84b48366&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b48366"]])

export default __exports__